import { Component, OnInit } from "@angular/core";
import { AdminService } from "../shared/admin.service";
import { take } from "rxjs/operators";
import { forkJoin } from "rxjs";
import { NgxSpinnerService } from "ngx-spinner";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { ChartOptions } from "chart.js";
import { AuthenticationService } from '../shared/authentication.service';
import { Permitions } from '../models/permitions.enum';
import { GraphService } from "../shared/graph.service";
import * as Highcharts from "highcharts";

import rounded from '../plugins/rounded-corner.js';
rounded(Highcharts)

Highcharts.setOptions({
  lang: {
    thousandsSep: '',
    numericSymbols: null
  }
});


@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
})
export class DashboardComponent implements OnInit {

  chatCustomerOptions: Highcharts.Options;
  selectedCustomerType = '1M';
  showCustomerDate = false;

  chatOrderOptions: Highcharts.Options;
  selectedOrderType = '1M';
  showOrderDate = false;

  chatSalesOptions: Highcharts.Options;
  selectedSalesType = '1M';
  showSalesDate = false;

  Highcharts: typeof Highcharts = Highcharts;



  public showNavbar: boolean = false;
  private token: any;
  public dashboardCounts: {
    totalOrders: number;
    totalSales: number;
    totalCustomers: number;
    totalDesigners: number;
  } = {
      totalOrders: 0,
      totalSales: 0,
      totalCustomers: 0,
      totalDesigners: 0,
    };
  graphRequest: number;
  graphRequest1: number;
  public Orders: any = [];
  public transactions: any = [];
  public isLoading: boolean = true;
  public transationForm: FormGroup;
  public changebleTransations: any = [];
  public showTransationLink: boolean = false;
  public selectedOrder: any = {};
  public visitSaleChartData: any;
  public visitSaleChartData1: any;
  public visitSaleChartLabels1: any;
  public visitSaleChartLabels: any;
  public visitSaleChartOptions: ChartOptions;
  public visitSaleChartColors: any;
  public visitSaleChartOptions1: ChartOptions;
  public visitSaleChartColors1: any;
  public showAnalytics: boolean = false;
  public permitions = Permitions;
  public date: Date = new Date();
  trackOrder: any = {};
  graphdata: any = {};
  graphdata1: any = {};
  public trackList: Array<any> = [];
  constructor(
    private adminService: AdminService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private router: Router,
    public authenticationService: AuthenticationService,
    public graphService: GraphService
  ) {
  }


  public ngOnInit(): void {
    document.querySelector("body").classList.add("move-main-panel");
    this.token =
      "Authorization:Bearer " + localStorage.getItem("A_accesstoken");
    this.transationForm = this.fb.group({
      transactionStatus: ["", Validators.required],
      trackingLink: [null],
      courierServices: [null],
    });
    this.trackOrder = JSON.parse(sessionStorage.getItem("trackOrder")) || null;
    this.getInitialData();
  }


  private getInitialData(): void {
    this.spinner.show();
    this.isLoading = true;
    forkJoin([
      this.adminService.getDashboardCounts(this.token),
      this.adminService.orders(this.token),
      this.adminService.getOrderTransactions(this.token),
      this.adminService.getDashboardAnalytics(this.token),
      this.adminService.getsalesAnalytics(this.token),

    ])
      .pipe(take(1))
      .subscribe((_) => {
        this.spinner.hide();
        this.isLoading = false;
        this.dashboardCounts = _[0];
        this.transactions = _[2];
        this.Orders = _[1];
        console.log('orders', this.Orders)
        console.log('transctions', this.transactions)

        this.populateAnalytics(_[3]);
        this.populatesales(_[4]);
        this.graphdata = _[3];
        this.graphdata1 = _[4];
        sessionStorage.setItem('OrdersGraphInfo', JSON.stringify(this.graphdata))
        sessionStorage.setItem('salesGraphInfo', JSON.stringify(this.graphdata1))
        this.loadChart('chatCustomerOptions', 'selectedCustomerType', this.graphdata);
        this.loadChart('chatOrderOptions', 'selectedOrderType', this.graphdata);
        this.loadChart('chatSalesOptions', 'selectedSalesType', this.graphdata1);
      });
  }

  loadChart(option, selectedDate, graphData, selectedType?) {
    const data = this.graphService.graphDataForm(selectedDate, this[selectedDate], graphData, selectedType);
    let pointFormat = '';
    if (option == 'chatSalesOptions') {
      pointFormat = '{point.y:f} Sales';
    } else if (option == 'chatCustomerOptions') {
      pointFormat = '{point.y:f} Customer';
    } else if (option == 'chatOrderOptions') {
      pointFormat = '{point.y:f} Order';
    }
    this[option] = this.graphService.loadChart(data, pointFormat)
  }

  selectedApp(event, option, selectedDate, data) {
    this[selectedDate] = event;
    this.loadChart(option, selectedDate, this[data]);
  }

  dateSelected(event, graphCountfor, graphOption, selectedType) {
    this[selectedType] = ''
    event && this.getAllGraphDataByCustomDate(this.graphService.formatDate(new Date(event[0])), this.graphService.formatDate(new Date(event[1])), graphCountfor, graphOption, selectedType)
  }


  getAllGraphDataByCustomDate(start, end, graphCountfor, graphOption, selectedType) {
    this.adminService.getAllGraphDataByCustomDate(this.token, start, end, graphCountfor).subscribe(res => {
      if (res) {
        this.loadChart(graphOption, selectedType, res, 'customGraph');
        if (selectedType == 'customGraph') {
          this[selectedType] = ''
        }
      }
    })
  }

  public getTransactionStatus(status: number): string {
    return this.transactions.find((_) => _.transactionId === status)
      .description;
  }

  public formateCounts(count: number): string {
    let fCount: string = "";
    if (count >= 1000000) {
      return (count / 1000000).toFixed(3) + "M";
    }
    // if (count >= 1000) {
    //   return (count / 1000).toFixed(2) + "K";
    // }
    return count.toString();
  }
  private getOrderTracking() {
    this.spinner.show();
    this.adminService
      .getOrderTracking(this.selectedOrder.orderTransationStatusId, this.token)
      .pipe(take(1))
      .subscribe(
        (res: any) => {
          this.spinner.hide();
          if (res) {
            const isCanceled = res.find(
              (_) => _.transactionStatus == 2 && _.isCompleted
            );
            if (isCanceled) {
              this.trackList = res.filter((_) => _.transactionStatus <= 2);
            } else {
              this.trackList = res.filter((_) => _.transactionStatus != 2);
            }
          }
        },
        (err) => {
          //console.log(err)
          this.spinner.hide();
          // this.toaster.error('Invalid User Name or Password.')
        }
      );
  }

  public changeTransationStatus(ModalContent: any, order: any): void {
    this.selectedOrder = order;
    this.getOrderTracking();
    if (order.transationStatusId !== 2) {
      this.changebleTransations = this.transactions.filter(
        (_) =>
          _.transactionId > order.transationStatusId &&
          _.transactionId <=
          (order.transationStatusId === 1
            ? order.transationStatusId + 2
            : order.transationStatusId + 1)
      );
      this.transationForm.patchValue({
        transactionStatus: this.changebleTransations[0].transactionId,
      });
      console.log(this.transactions);
      console.log(this.changebleTransations[0].transactionId)

      this.showTransationLink = order.transationStatusId === 3;
      if (this.showTransationLink) {
        this.transationForm
          .get("trackingLink")
          .setValidators([Validators.required]);
        this.transationForm
          .get("courierServices")
          .setValidators([Validators.required]);
        this.transationForm.updateValueAndValidity();
      } else {
        this.transationForm.get("trackingLink").clearValidators();
        this.transationForm.get("courierServices").clearValidators();
        this.transationForm.updateValueAndValidity();
      }
      this.modalService.open(ModalContent, {
        size: "lg",
        backdrop: "static",
        keyboard: false,
      });
    }
  }

  public updateTransationStatus(): void {
    if (this.transationForm.valid) {
      this.spinner.show();
      const transactionStatus = parseInt(
        this.transationForm.get("transactionStatus").value
      );
      const courierServices =
        this.transationForm.get("courierServices").value || null;
      const trackingLink =
        this.transationForm.get("trackingLink").value || null;
      const data = {
        orderId: this.selectedOrder.orderId,
        transactionStatus,
        courierServices,
        trackingLink,
      };
      this.adminService
        .updateTransationStatus(data, this.token)
        .pipe(take(1))
        .subscribe((_: any) => {
          this.spinner.hide();
          if (_ && _.status === 1) {
            this.selectedOrder.transationStatusId = transactionStatus;
            this.selectedOrder.courierServices = courierServices;
            this.selectedOrder.trackingLink = trackingLink;
            //this.toaster.success('Transation Status Updated successfully..');
          } else {
            //this.toaster.error('Error occured');
          }
          this.modalService.dismissAll();
        });
    }
  }
  getchartnumber(id: number) {
    this.graphRequest = id;
    this.populateAnalytics(this.graphdata);
  }
  getchartnumber1(id: number) {
    this.graphRequest1 = id;
    this.populatesales(this.graphdata1);
  }
  
  
  viewdetails(item: any): void {
    this.router.navigate(['orders/orders/view', item.orderId ]);
  }

  private populateAnalytics(chartData: any) {
    console.log("chart data", chartData);
    const orderData = [];
    const CustomersData = [];
    this.visitSaleChartLabels = [];
    if (this.graphRequest == null) {
      this.graphRequest = 3
    }

    if (this.graphRequest == 3) {
      chartData.threeMonths.forEach((_) => {
        orderData.push(_.ordersCount);
        this.visitSaleChartLabels.push(_.monthName + ' ' + _.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
        CustomersData.push(_.customercount);
      });
    }
    else if (this.graphRequest == 6) {
      chartData.sixMonths.forEach((_) => {
        orderData.push(_.ordersCount);
        this.visitSaleChartLabels.push(_.monthName + ' ' + _.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
        CustomersData.push(_.customercount);
      });
    }
    else if (this.graphRequest == 12) {
      chartData.yeartoDate.forEach((_) => {
        orderData.push(_.ordersCount);
        this.visitSaleChartLabels.push(_.monthName + ' ' + _.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
        CustomersData.push(_.customercount);
      });
    }
    else if (this.graphRequest == 15) {
      chartData.oneYear.forEach((_) => {
        orderData.push(_.ordersCount);
        this.visitSaleChartLabels.push(_.monthName + ' ' + _.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
        CustomersData.push(_.customercount);
      });
    }
    else if (this.graphRequest == 36) {
      chartData.threeYears.forEach((_) => {
        orderData.push(_.ordersCount);
        this.visitSaleChartLabels.push(_.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
        CustomersData.push(_.customercount);
      });
    }

    else if (this.graphRequest == 40) {
      chartData.maxYears.forEach((_) => {
        orderData.push(_.ordersCount);
        this.visitSaleChartLabels.push(_.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
        CustomersData.push(_.customercount);
      });
    }



    this.visitSaleChartData = [
      {
        label: "Orders",
        data: orderData,
        maxBarThickness: 6,
        categoryPercentage: 0.2
      },

      {
        label: "Customers",
        data: CustomersData,
        maxBarThickness: 6,
        categoryPercentage: 0.2
      },
    ];
    console.log(this.visitSaleChartData)
    this.visitSaleChartOptions = {
      responsive: true,
      scales: {
        yAxes: [
          {
            gridLines: {
              drawBorder: true,
              color: "#606c91",
              zeroLineColor: "#DAE1F7",

            },
            ticks: {
              padding: 10,
              fontColor: "#DAE1F7",
              fontSize: 14,
              stepSize: 1,
              beginAtZero: true,
            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: false,
              drawBorder: true,
              color: "#606c91",
              zeroLineColor: "rgba(235,237,242,1)",
            },
            ticks: {
              padding: 10,
              fontColor: "#DAE1F7",
              fontSize: 14


            },
          },
        ],
      },
    };

    this.visitSaleChartColors = [
      { backgroundColor: "#F86047", borderColor: "#F86047" },
      { backgroundColor: "#CFD9DF", borderColor: "#CFD9DF" },
    ];

    this.showAnalytics = true;
  }
  private populatesales(chartData1: any) {
    console.log("chart data", chartData1);
    const salesData = [];
    this.visitSaleChartLabels1 = [];
    if (this.graphRequest1 == null) {
      this.graphRequest1 = 13
    }

    if (this.graphRequest1 == 13) {
      chartData1.threeMonths.forEach((_) => {
        salesData.push(_.saleAmount);
        this.visitSaleChartLabels1.push(_.monthName + ' ' + _.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
      });
    }
    else if (this.graphRequest1 == 16) {
      chartData1.sixMonths.forEach((_) => {
        salesData.push(_.saleAmount);
        this.visitSaleChartLabels1.push(_.monthName + ' ' + _.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
      });
    }
    else if (this.graphRequest1 == 112) {
      chartData1.yeartoDate.forEach((_) => {
        salesData.push(_.saleAmount);
        this.visitSaleChartLabels1.push(_.monthName + ' ' + _.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
      });
    }
    else if (this.graphRequest1 == 115) {
      chartData1.oneYear.forEach((_) => {
        salesData.push(_.saleAmount);
        this.visitSaleChartLabels1.push(_.monthName + ' ' + _.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
      });
    }
    else if (this.graphRequest1 == 136) {
      chartData1.threeYears.forEach((_) => {
        salesData.push(_.saleAmount);
        this.visitSaleChartLabels1.push(_.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
      });
    }

    else if (this.graphRequest1 == 140) {
      chartData1.maxYears.forEach((_) => {
        salesData.push(_.saleAmount);
        this.visitSaleChartLabels1.push(_.year);
        //});
        // chartData.yearWiseCustomers.forEach((_) => {
      });
    }



    this.visitSaleChartData1 = [
      {
        label: "sales",
        data: salesData,
        maxBarThickness: 6,
        categoryPercentage: 0.2
      },

      // {
      //   label: "Customers",
      //   data: CustomersData,
      //   maxBarThickness:6,
      //   categoryPercentage: 0.2
      // },
    ];
    console.log(this.visitSaleChartData1)
    this.visitSaleChartOptions1 = {
      responsive: true,
      scales: {
        yAxes: [
          {
            gridLines: {
              drawBorder: true,
              color: "#606c91",
              zeroLineColor: "#DAE1F7",
            },
            ticks: {
              padding: 10,
              fontColor: "#DAE1F7",
              fontSize: 14,
              stepSize: 1,
              beginAtZero: true,

            },
          },
        ],
        xAxes: [
          {
            gridLines: {
              display: false,
              drawBorder: true,
              color: "#606c91",
              zeroLineColor: "rgba(235,237,242,1)",
            },
            ticks: {
              padding: 10,
              fontColor: "#DAE1F7",
              fontSize: 14


            },
          },
        ],
      },
    };

    this.visitSaleChartColors1 = [
      { backgroundColor: "#CFD9DF", borderColor: "#CFD9DF" },
      { backgroundColor: "rgba(54, 162, 235, 0.8)", borderColor: "rgba(54, 162, 235, 1)" },
    ];

    this.showAnalytics = true;
  }
  // sales end
  trafficChartData = [
    {
      data: [30, 30, 40],
    },
  ];

  trafficChartLabels = ["Search Engines", "Direct Click", "Bookmarks Click"];

  trafficChartOptions = {
    responsive: true,
    animation: {
      animateScale: true,
      animateRotate: true,
    },
    legend: false,
  };

  trafficChartColors = [
    {
      backgroundColor: [
        "rgba(177, 148, 250, 1)",
        "rgba(254, 112, 150, 1)",
        "rgba(132, 217, 210, 1)",
      ],
      borderColor: [
        "rgba(177, 148, 250, .2)",
        "rgba(254, 112, 150, .2)",
        "rgba(132, 217, 210, .2)",
      ],
    },
  ];

  setAssignOrder(item: any): void {
    this.router.navigate(['orders/orders/assign', item.orderId]);
  }
}
